// extracted by mini-css-extract-plugin
module.exports = {"eliteNumbersWrapper":"_15620","nubmerBg":"J_8KM","numberTextWrapper":"_1SFIc","numberText":"_3rUWW"};